import { useCallback } from 'react';
import { StreamingUgcPlatform } from 'fym-shared/src/music24/streamingSections';
import { useGetStreamingShortVideoQuery } from '../../../../redux/api/fymAPI';

/** Streaming → Short video (design streaming-sections c1, c2): one platform, or all. */
export function useStreamingShortVideo(input: {
  accountId: number;
  days: number;
  source: string | undefined;
  platform: StreamingUgcPlatform | undefined;
  skip: boolean;
}) {
  const { accountId, days, source, platform, skip } = input;
  const read = useGetStreamingShortVideoQuery({ accountId, days, source, platform }, { skip });
  const { refetch } = read;
  const retry = useCallback(() => {
    refetch().catch(console.error);
  }, [refetch]);
  return { data: read.data, isLoading: read.isLoading, error: read.error, retry };
}
